import React from "react";
import { Box, Typography, CardContent, LinearProgress } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { AcademicYearStatusStatsDto } from "../../../shared/dtos/academicYear/AcademicYearStatusStatsDto";

interface AcademicYearWidgetProps {
  data: AcademicYearStatusStatsDto;
}

interface StatusItem {
  label: string;
  value: number;
  color: "success" | "info" | "inherit";
}

const AcademicYearWidget: React.FC<AcademicYearWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("ACADEMIC_YEAR");
  const Icon = meta.icon;

  const statuses: StatusItem[] = [
    { label: "Active", value: data.active, color: "success" },
    { label: "Completed", value: data.completed, color: "info" },
    { label: "Inactive/Draft", value: data.inactive, color: "inherit" },
  ];

  const total = data.total || 1;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {meta.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total Years: {data.total}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {statuses.map((s, index) => (
            <Box key={index}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography variant="body2">{s.label}</Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {s.value}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={(s.value / total) * 100}
                color={s.color}
                sx={{ height: 6, borderRadius: 3 }}
              />
            </Box>
          ))}
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default AcademicYearWidget;
